import api from '../../api'

export default {
  props: {
    token: {
      default: ''
    }
  },
  name: 'CompleteInvite',
  data: () => {
    return {
      email: '',
      firstName: '',
      lastName: '',
      password: '',
      password2: ''
    }
  },
  computed: {
    isInvalid () {
      return Object.values(this.fields).some(x => !x.valid)
    }
  },
  methods: {
    completeInvite () {
      if (this.isInvalid) return
      const userInfo = {
        firstName: this.firstName,
        lastName: this.lastName,
        password: this.password,
        password2: this.password2
      }
      api.post.updateInvitedUser(this.token, userInfo)
        .then(() => {
          this.$router.push('/login')
        })
        .catch(() => this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        }))
    }
  },
  created () {
    api.get.invitedUser(this.token)
      .then((response) => {
        this.email = response.data.data.username
      })
      // .catch(() => this.$router.push('/login'))
  }
}
